import styled from 'styled-components';

import Button from 'components/common/Button';

export const StyledButton = styled(Button)`
  padding: 0.9rem 1.6rem;
  width: auto;
`;
